export class CredentialsProbeWriteResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ok",
            "baseName": "ok",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "ProbeError",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CredentialsProbeWriteResponse.attributeTypeMap;
    }
    constructor() {
    }
}
